import { render, staticRenderFns } from "./LeavePresentations.vue?vue&type=template&id=c45883ec&"
import script from "./LeavePresentations.vue?vue&type=script&lang=js&"
export * from "./LeavePresentations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports